import React from "react";

function Footer() {
  return (
    <div className="page-footer">
      <div className="page-footer-inner">
        Powered By{" "}
        <a href="http://infospec.org" target="_blank">
          Infospec
        </a>{" "}
        &copy; {new Date().getFullYear()} <br />
        For any inquiry, please contact us on 07367533331 or
        info@clinicalspec.com
      </div>
      <div className="scroll-to-top">
        <i className="material-icons">eject</i>
      </div>
    </div>
  );
}

export default Footer;
